type BadgeVariant = 'success' | 'info' | 'warning' | 'danger' | 'secondary';

/**
 * Maps an employee lifecycle status to a SoftBadge color variant.
 *
 * The status values come from the flair__Status__c picklist on flair__Employee__c.
 * This picklist is unrestricted, so customers can add custom values — unknown values
 * fall back to 'secondary'.
 */
export const getEmployeeStatusBadgeVariant = (status: string): BadgeVariant => {
  switch (status) {
    case 'Employed':
      return 'success';
    case 'Preonboarding':
    case 'Onboarding':
      return 'info';
    case 'Probation':
    case 'On Leave':
    case 'Garden Leave':
      return 'warning';
    case 'Inactive':
      return 'danger';
    default:
      return 'secondary';
  }
};
